import { Pencil, X } from "lucide-react";
import { TourCompanyFormData } from "./tour-company-modal";



export default function TourCompanyList({ tourCompanies, onEdit, onRemove, showActionButtons=true }: {
    tourCompanies: any;
    onEdit: (shareholder: TourCompanyFormData) => void;
    onRemove: (shareholder: TourCompanyFormData) => void;
    showActionButtons?: boolean
}) {

    const getInitials = (companyName: string) => {
        return (companyName?.[0] + companyName?.[1] || "").toUpperCase();
    };


    return (
        <div className={`w-full space-y-2  mt-5 ${showActionButtons && "grid grid-cols-2 gap-4"}`}>
            {tourCompanies?.map((tourCompany: any) => (
                <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5">
                    <div key={tourCompany.salutation} className="flex items-center justify-between ">
                        <div className="flex items-center gap-4">
                            <div className="w-11 h-11 rounded-full bg-gray-100 flex items-center justify-center">
                                <span className="text-sm text-orange-500 font-medium">
                                    {getInitials(tourCompany.companyName)}
                                </span>
                            </div>
                            <div className="space-y-1">
                                <div>
                                    <h3 className="text-sm font-bold text-[#48505E]">
                                        {tourCompany.companyName}
                                    </h3>
                                    <p className="text-sm text-[#6B5C4F] font-extralight">
                                        {tourCompany.tourCompanyTransfer}
                                    </p>
                                </div>
                            </div>

                        </div>

                        <div>
                            {
                                showActionButtons && (
                                    <div className="flex items-center gap-4">
                                    <button
                                        type="button"
                                        onClick={() => onEdit(tourCompany)}
                                        className="p-2 hover:bg-gray-50 rounded-lg transition-colors"
                                    >
                                        <Pencil size={20} className="text-gray-600" />
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => onRemove(tourCompany)}
                                        className="p-2 hover:bg-gray-50 rounded-lg transition-colors"
                                    >
                                        <X size={20} className="text-gray-600" />
                                    </button>
                                </div>
                                )
                            }
                        </div>
                  
                    </div>
                    <div className="flex flex-wrap gap-2 mt-2">
                        {tourCompany.excursionCompanies?.map((excursionCompany: any) => (
                            <div className="text-xs text-[#6B5C4F]  font-bold bg-[#F2F0ED] rounded">
                                <div className="p-1 w-full text-left capitalize">
                                    {excursionCompany}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}